import React from 'react'
import { Row, Container, Col, Card, Image } from "react-bootstrap";

import aboutImg from "../../Assets/about-img.png"
import aboutImg1 from "../../Assets/about-img-1.png"

export default function Services() {
    return (
        <section className='padding-section-large'>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">More Than Just a <span className="text-gradient-1">Software Company</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A perspective formed through experience and a focus on getting things right over time. </h5>
                    </Col>
                </Row>
                <Row className="d-flex align-items-stretch">
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="shadow-sm rounded-0 primary-border light-bg logo-bg">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Card.Text className="mb-5">Parabola IT is an offshore software development company founded in 2009, with a clear focus on solving business problems where accuracy, structure, and long-term reliability were non-negotiable. </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border">
                            <Card.Body className='p-4  d-flex flex-column'>
                                <Card.Text className="mb-5">With over 17 years of experience, we’ve worked on systems where even small inconsistencies could have a direct business impact. That experience shaped how we think about software, not as isolated features, but as systems that need to hold up over time.  </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Image src={aboutImg1} className='img-fluid' />
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Image src={aboutImg} className='img-fluid' />
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Card.Text className="mb-4">Over time, this has become less of a process and more of a way of thinking across the team. </Card.Text>
                                <Card.Text className="">This mindset continues to guide how we approach every engagement. We approach every engagement with a balance of development, quality and reliability, ensuring that what is delivered continues to work as expected, long after it goes live. </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={4} className="mb-4 d-flex" >
                        <Card className="rounded-0 secondary-border">
                            <Card.Body className='p-4 d-flex flex-column'>
                                <Card.Text className="mb-5">Over the years, we’ve evolved into a team that values clarity in execution, discipline in engineering, and a strong sense of ownership in everything we do. </Card.Text>

                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </section>
    )
}
